import { React } from "react";
import backIcon from "..//assets/res/back_black.svg";
import appleIcon from "..//assets/res/apple_black.svg";
import androidIcon from "..//assets/res/android_green.svg";
import downloadIcon from "../assets/res/download.svg";
import { GET_BASE_URL } from "../utils/Constants";

const InfoBlock = ({ title, value }) => {
  return (
    <div className="flex min-w-[92px] flex-col items-center justify-center px-4 text-center">
      <div className="semiBold max-w-[84px] truncate text-xl leading-none text-dark">
        {value}
      </div>
      <div className="medium mt-1 text-[11px] uppercase tracking-[0.12em] text-gray-400">
        {title}
      </div>
    </div>
  );
};

const InfoBlockPlatform = ({ title, isForAndroid, isForIos }) => {
  return (
    <div className="flex min-w-[92px] flex-col items-center justify-center px-4 text-center">
      <div className="flex h-[24px] flex-row items-center justify-center gap-2">
        {isForAndroid && <img src={androidIcon} className="h-5 w-5" />}
        {isForIos && <img src={appleIcon} className="h-5 w-5" />}
      </div>
      <div className="medium mt-1 text-[11px] uppercase tracking-[0.12em] text-gray-400">
        {title}
      </div>
    </div>
  );
};

function PageDetails({ app, handleClose, openLoading }) {
  return (
    <div className="relative z-10 flex min-h-screen flex-col mb-[300px] lg:mx-auto lg:w-[500px] lg:border-[1px] lg:border-gray-200">
      {/* transparent overlay header */}
      <div className="flex items-center gap-3 px-4 pt-4 ">
        <button
          onClick={handleClose}
          className="flex h-9 w-9 items-center justify-center transition active:scale-90"
        >
          <img src={backIcon} alt="Back" className="h-[20px] w-[20px]" />
        </button>
        <span className="semiBold truncate text-xl text-dark">{app.name}</span>
      </div>

      <div className="px-5 pb-48 pt-2 ">
        {/* hero image with brand glow */}
        <div className="relative mx-auto mt-6 w-56">
          <div className="absolute inset-0 translate-y-3 scale-90 rounded-[28px] bg-primary/30 blur-2xl" />
          <div className="relative overflow-hidden rounded-[28px] border border-white shadow-xl shadow-primary/20 ring-1 ring-black/5">
            <img
              src={GET_BASE_URL() + "images/" + app.image}
              alt={app.name}
              className="h-56 w-56 object-cover"
            />
          </div>
        </div>

        <h1 className="semiBold mt-5 text-center text-3xl leading-tight text-dark">
          {app.name}
        </h1>

        <div className="mt-2 flex justify-center">
          <span className="medium rounded-full bg-primary/10 px-3 py-1 text-xs uppercase tracking-[0.14em] text-primary">
            {app.category}
          </span>
        </div>

        {/* stats row */}
        <div className="no-scrollbar mt-6 flex flex-row items-stretch divide-x divide-gray-200 overflow-x-auto rounded-2xl border border-gray-200 bg-white py-4 shadow-sm">
          <InfoBlock title="Rating" value={app.rating} />
          <InfoBlock title="Developer" value={app.author} />
          <InfoBlockPlatform
            title="Platform"
            isForAndroid={app.isForAndroid}
            isForIos={app.isForIos}
          />
          <InfoBlock title="Downloads" value={app.download} />
          <InfoBlock title="Size" value={app.size} />
        </div>

        {/* description */}
        <div className="mt-6">
          <div className="mb-2 flex items-center gap-[10px]">
            <span className="h-[16px] w-[4px] rounded-full bg-primary" />
            <h2 className="semiBold text-xl text-dark">About</h2>
          </div>
          <p className="medium text-[15px] leading-relaxed text-gray-600">
            {app.description}
          </p>
        </div>
      </div>


      {/* sticky download CTA */}
      <div className="fixed bottom-0 left-0 right-0 z-20 mx-auto bg-gradient-to-t from-white via-white to-transparent px-5 pb-6 pt-8  lg:w-[500px]">
        <button
          onClick={openLoading}
          className="semiBold flex w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-primary to-primaryDark py-4 text-lg text-white shadow-lg shadow-primary/30 transition active:scale-[0.98]"
        >
          <span>Download</span>
          <img src={downloadIcon} className="h-5 w-5" />
        </button>

      </div>
    </div>
  );
}

export default PageDetails;
